import { CartFund, ProductType, UnitCategoryCode, KorpoEmployerFundData, PRODUCTS } from 'cart-model';
import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ProductWizardState from '../../../model/ProductWizardState';
import IkzeExtendedEntrepreneurDepositAgreement
  , { IkzeExtendedEntrepreneurDepositAgreementForm } from '../../IkzeExtendedEntrepreneurDeposit/IkzeExtendedEntrepreneurDepositAgreement';
import { AmountValidationError, AmountValidationErrorType } from '../cartValidation';
import SetAmountsFundBox from '../SetAmountsFundBox/SetAmountsFundBox';
import { Typography } from 'ui-components';

import useStyles from './SetAmountsProductSection.style';

const IkzeExtendedFormSection: React.FC<{
  handleIkzeExtendedFormChange: (values: IkzeExtendedEntrepreneurDepositAgreementForm, valid: boolean) => void;
}> = ({handleIkzeExtendedFormChange}) => {
  const c = useStyles({});
  const isEntrepreneur = useSelector((state: ProductWizardState) => state.cartState.isEntrepreneur);
  const entrepreneurNip = useSelector((state: ProductWizardState) => state.cartState.entrepreneurNip);
  const [ikzeFormValid, setIkzeFormValid] = useState(true);
  const initialIkzeFormValues: IkzeExtendedEntrepreneurDepositAgreementForm ={
    isEntrepreneur: isEntrepreneur ? isEntrepreneur : false,
    nip: isEntrepreneur ? entrepreneurNip : undefined,
    entrepreneurConsent: isEntrepreneur ? true : undefined,
  };

  return (
    <IkzeExtendedEntrepreneurDepositAgreement
      className={c.ikzeBox}
      initialValues={initialIkzeFormValues}
      handleValid={(valid) => setIkzeFormValid(valid)}
      handleChange={(values) => handleIkzeExtendedFormChange(values, ikzeFormValid)}
    />
  );
};

const SetAmountsProductSection: FunctionComponent<{
  showHeader: boolean;
  productType: ProductType;
  unitCategory: UnitCategoryCode;
  cartFunds: CartFund[];
  validationError: AmountValidationError;
  cartFundToValidationError: Map<CartFund, AmountValidationError>;
  handleIkzeExtendedFormChange: (values: IkzeExtendedEntrepreneurDepositAgreementForm, valid: boolean) => void;
  korpoFunds?: KorpoEmployerFundData[];
  sumError?: boolean;
}> = ({ showHeader, productType, unitCategory, korpoFunds, cartFunds, validationError, cartFundToValidationError, handleIkzeExtendedFormChange, sumError }) => {

  const c = useStyles({});
  const [t] = useTranslation('set-amounts-per-fund');

  const [focusedCartFund, setFocusedCartFund] = useState(cartFunds.length > 0 ? cartFunds[0] : undefined);

  if (focusedCartFund === undefined) {
    return null;
  }

  return (
    <>
      {showHeader &&
        <div className={c.fundTitleWrapper}>
          <Typography variant="body2" className={c.fundTitle}>
            {t(`product-type.${productType}`)}
          </Typography>
        </div>
      }
      {productType === ProductType.ikze &&
        <IkzeExtendedFormSection handleIkzeExtendedFormChange={handleIkzeExtendedFormChange}/>
      }
      {cartFunds.map((cartFund, index) => {
        let cartFundValidationError = cartFundToValidationError.get(cartFund)!;
        if (cartFundValidationError.type === AmountValidationErrorType.NONE
            && cartFund.fund === focusedCartFund.fund) {
          cartFundValidationError = validationError;
        }
        let minAmount = PRODUCTS[cartFund.productType].minimalAmount;
        if (korpoFunds != null) {
          const korpoFund = korpoFunds.find(kf => kf.fundId === cartFund.fund.id);
          if (korpoFund != null && korpoFund.minPurchaseOpening != null) {
            minAmount = korpoFund.minPurchaseOpening;
          }
        }
        const finalSumError = !!sumError || validationError.type === AmountValidationErrorType.MAX;

        return (<SetAmountsFundBox key={cartFund.fund.id}
                                    unitCategory={unitCategory}
                                    minAmount={minAmount}
                                    cartFund={cartFund}
                                    validationError={cartFundValidationError}
                                    sumError={finalSumError}
                                    onInputFocus={() => setFocusedCartFund(cartFund)}
                                    index={index}/>);
      })}
    </>
  );
};

export default SetAmountsProductSection;
